import React, { useState } from 'react';
import { observer } from 'mobx-react';

import classes from './SelfBillingPaymentStep.module.scss';
import {
  CoachSeatsWidget,
  FeeModuleWidget,
  FreeAccessWidget,
  SelfBillingFeeTermsWidget,
} from '../../../../../../payment';
import { ButtonsRow } from '../../../components/ButtonsRow/ButtonsRow';
import { setupEntityStore } from '../../../../../stores/setupEntityStore';

const SelfBillingPaymentStep = observer(() => {
  const [isFeeModuleCreated, setIsFeeModuleCreated] = useState(false);
  const [isFeeTermsCreated, setIsFeeTermsCreated] = useState(false);
  const [isCoachSeatsCreated, setIsCoachSeatsCreated] = useState(false);

  const { entityId, entityType, stepperMethods } = setupEntityStore;
  const { goToNextStep } = stepperMethods;

  if (!entityId || !entityType) {
    throw new Error('Entity id, entity type or billing type is not defined');
  }

  const isNextBtnDisabled =
    !isFeeModuleCreated || !isFeeTermsCreated || !isCoachSeatsCreated;

  return (
    <div>
      <div className={classes.row}>
        <div className={classes.column}>
          <FeeModuleWidget
            entityType={entityType}
            className={classes.moduleFormBlock}
            entityId={entityId}
            onSuccessSubmit={() => {
              setIsFeeModuleCreated(true);
            }}
          />
        </div>
        <SelfBillingFeeTermsWidget
          entityId={entityId}
          isFeeTermsCreated={isFeeTermsCreated}
          onSuccessSubmit={() => {
            setIsFeeTermsCreated(true);
          }}
        />
      </div>
      <CoachSeatsWidget
        entityId={entityId}
        isCoachSeatsCreated={isCoachSeatsCreated}
        onSuccessSubmit={() => {
          setIsCoachSeatsCreated(true);
        }}
      />
      <FreeAccessWidget entityId={entityId} />
      <ButtonsRow onNext={goToNextStep} yesDisabled={isNextBtnDisabled} />
    </div>
  );
});

export { SelfBillingPaymentStep };
